import PrivacyPolicyPage from 'screens/Contract/PrivacyPolicy/PrivacyPolicy';

export default PrivacyPolicyPage;
